// ./src/components/loadings/LoadingProfile/styles.ts
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  /* background-color: ${({ theme }) => theme.colors.white.main}; */
  text-align: center;
  margin: 3vh 0 0;
  width: 100%;
  border-radius: 10px;
`;
